import client from './client';
import type { ProductCollection } from '@/types/api';

export const collectionsApi = {
  getAll: async (includeInactive = false): Promise<ProductCollection[]> => {
    const response = await client.get<ProductCollection[]>('/collections', {
      params: { includeInactive },
    });
    return response.data;
  },

  getById: async (id: string): Promise<ProductCollection> => {
    const response = await client.get<ProductCollection>(`/collections/${id}`);
    return response.data;
  },

  create: async (data: Partial<ProductCollection>): Promise<ProductCollection> => {
    const response = await client.post<ProductCollection>('/collections', data);
    return response.data;
  },

  update: async (id: string, data: Partial<ProductCollection>): Promise<ProductCollection> => {
    const response = await client.put<ProductCollection>(`/collections/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/collections/${id}`);
  },

  seedDefaults: async (): Promise<void> => {
    await client.post('/collections/seed');
  },
};
